export const getPublicPath = (path: string): string => {
  return `${process.env.REACT_APP_PUBLIC_URL ?? ''}/${path}`
}
